import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface ChangePasswordRequest {
  oldPassword: string;     // 舊密碼
  newPassword: string;     // 新密碼
  confirmPassword: string; // 確認新密碼
}

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pw0113f1Api = {
  async changePassword(data: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    const res = await apiClient.post('/api/pw0113f1/change-password', data);
    return res.data;
  },
};
